import { createStore } from 'vuex'

import CourseModule from './store/courses'
import MyUserModule from './store/myUser'
import Pages from './store/pages'
import Orders from "./store/orders";

const modules = {
  courses: CourseModule,
  myuser: MyUserModule,
  pages: Pages,
  orders: Orders
}

export default createStore({
  modules
})

